<p-toast
  position="top-right"
  [styleClass]="'custom-toast ' + (currentSeverity ? 'toast-' + currentSeverity : '')"
>
  <ng-template let-message pTemplate="message">
    <div class="custom-toast-content">
      <img [src]="getIcon(message.severity)" class="toast-icon" alt="toast-icon" />
      <div class="toast-text-container">
        <div class="toast-title">{{ message.summary | translate }}</div>
        <div class="toast-detail">{{ message.detail | translate }}</div>
      </div>
    </div>
  </ng-template>
</p-toast>
